import { gql } from "@apollo/client";
import { Grid } from "@mui/material";
import { HeaderGrid } from "components/atoms/HeaderGrid";
import { RobotListCard } from "components/modules/RobotListCard";
import { IRobot, Organization } from "gql/graphql";
import { useNavigate, useParams } from "react-router-dom";
import { getIsForbidden } from "utils/privileges/privilegeUtils";
import { useQueryWithSnack } from "utils/useQueryWithSnack";
import { ROUTES } from "../../routing/Routes";
import { ForbiddenPage } from "./ForbiddenPage";

//LSBRI TODO: If we ever get customers with a very large number of robots,
//            we should add a pagination to this query similar to what is done for support users robot list
const QUERY = gql(`
  query OrganizationRobotListPage($orgIds: [String!]) {
    organizations(filter: { ids: $orgIds }) {
      name
    }
    robots(organizationIds: $orgIds) {
      robots {
        id
        serialNumber
        robotType
        active {
          organization {
            id
            name
            country
          }
          nickname
        }
        ... on UvdRobot {
          status {
            batteryMergerPercentage
            lastTimeActive
            job {
              state
              type
            }
          }
          version {
            seto
          }
        }
      }
    }
  }
`);

export const OrganizationRobotListPage = () => {
  const navigate = useNavigate();
  const { orgId, orgIds } = useParams();
  const orgIdsArray = (orgId ? [orgId] : []).concat(orgIds?.split("+") ?? []);

  const { data, error } = useQueryWithSnack(QUERY, {
    variables: { ...(orgIdsArray.length > 0 ? { orgIds: orgIdsArray } : {}) },
    skip: orgId === "support",
    fetchPolicy: "no-cache",
    pollInterval: 10000,
  });

  const robots = data?.robots.robots as IRobot[] | undefined;

  const sortedRobots = robots
    ?.map((item) => ({
      ...item,
      dataSource: orgIdsArray.includes(item.active?.organization.id || ""),
    }))
    .sort((x, y) => {
      return x.dataSource === y.dataSource ? 0 : x.dataSource ? 1 : -1;
    });

  const forbidden = getIsForbidden(error);
  if (forbidden) return <ForbiddenPage />;

  return (
    <Grid container spacing={6}>
      <HeaderGrid
        crumbs={[
          {
            label:
              orgId || orgIds
                ? data?.organizations
                  ? data?.organizations
                      .map((org: Organization) => org.name)
                      .join("+")
                  : "-"
                : "-",
          },
          { label: "Robots" },
        ]}
      />
      <Grid item>
        <Grid container spacing={6}>
          {(sortedRobots ?? []).map((robot) => (
            <RobotListCard
              key={robot.id}
              robot={robot}
              onClick={() =>
                navigate(
                  ROUTES.organization.robot
                    .replace(":orgId", robot.active?.organization.id || "")
                    .replace(":robotId", robot.id),
                )
              }
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
